import React from 'react';

/**
 * The map's error boundary (KPR-392). It catches whatever throws while the
 * map draws — above all a map chunk that never arrives (offline, or an open
 * tab after a deploy replaced the hashed file) — and hands the failure to
 * `fallback(retry)`, so the list beside the map carries on.
 *
 * It imports nothing but React, so LazyItemsMap can keep it in the main bundle
 * and catch a chunk that failed to download.
 */
export default class MapBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { failed: false };
		this.retry = this.retry.bind(this);
	}

	static getDerivedStateFromError() {
		return { failed: true };
	}

	componentDidCatch(error) {
		if (typeof console !== 'undefined' && console.error) console.error(error);
	}

	retry() {
		this.setState({ failed: false });
		if (typeof this.props.onRetry === 'function') this.props.onRetry();
	}

	render() {
		if (!this.state.failed) return this.props.children;
		return typeof this.props.fallback === 'function' ? this.props.fallback(this.retry) : null;
	}
}
